export enum AuditEntityType {
  ACTIVATION_PACKAGE = 'activation_package',
  FIRM = 'firm',
  PARTY = 'party',
  PAYMENT_INSTRUCTION = 'payment_instruction',
  PAYOUT_INSTRUCTION = 'payout_instruction',
  DOCUMENT = 'document'
}

export enum AuditAction {
  START_REVIEW = 'start_review',
  APPROVE = 'approve',
  REQUEST_CLARIFICATION = 'request_clarification',
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete'
}

export enum AuditActorKind {
  FIRM_USER = 'firm_user',
  OPS_USER = 'ops_user',
  SYSTEM = 'system'
}
